import React from 'react';
import classNames from 'clsx';

import {
  FormControl,
  IconButton,
  InputAdornment,
  TextField,
} from '@material-ui/core';
import Event from '@material-ui/icons/Event';
import InputMask from 'react-input-mask';

import { UtilService } from 'app/services/util.service';
import { LabelEnum } from 'app/shared/enums';
import isLabelFitToInput from 'app/shared/helpers/isLabelFitToInput';
import { DoneAdornment } from 'app/components/DoneAdornment';
import { ControlContainer } from 'app/components/ControlContainer';
import { DateControlDialog } from 'app/components/Controls/DateControlDialog';
import { useDateControl } from './useDateControl';
import { DateControlProps } from './DateControl.interfaces';
import { useStyles } from './DateControl.styles';

const DateControl = (props: DateControlProps) => {
  const {
    meta,
    meta: { touched, valid },
    subLabel,
    helperText,
    tooltip,
    tooltipIcon,
    disabled,
    label,
    width,
    input,
    adjustedWidth,
    datePickerViewType,
    isExtended,
    maxDate,
    initialFocusedDate,
    startDate,
    withMarginIfValid,
    withoutDoneAdornment,
    classes: customClasses,
    disableCenturyView,
    renderDialog = true,
  } = props;

  const {
    open,
    focused,
    minDate,
    calendarChange,
    handleClose,
    getCalendarValue,
    handleChange,
    handleBlur,
    handleFocus,
    getInputValue,
    handleClickOpen,
    handleClick,
  } = useDateControl(props);

  const classes = useStyles();

  return (
    <>
      {renderDialog && (
        <DateControlDialog
          open={open}
          isExtended={isExtended}
          minDate={minDate}
          maxDate={maxDate}
          startDate={startDate}
          datePickerViewType={datePickerViewType}
          initialFocusedDate={initialFocusedDate}
          handleClose={handleClose}
          calendarChange={calendarChange}
          getCalendarValue={getCalendarValue}
          fieldId={input.name}
          disableCenturyView={disableCenturyView}
        />
      )}
      <ControlContainer
        inputId={input.name}
        tooltip={tooltip}
        tooltipIcon={tooltipIcon}
        subLabel={subLabel}
        helperText={helperText}
        meta={meta}
        focused={focused}
        label={!isLabelFitToInput(label, width) ? label : ''}
        width={width}
        classes={{
          withBulb: classNames({ [classes.adjustedWidth]: adjustedWidth }),
          root: customClasses?.root,
          controlWrapper: customClasses?.controlWrapper,
        }}
        className={customClasses?.container}
      >
        <FormControl fullWidth className={customClasses?.formControl}>
          <InputMask
            {...input}
            mask={'99-99-9999'}
            maskChar={null}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            value={getInputValue()}
          >
            {() => (
              <TextField
                id={input.name}
                InputProps={{
                  startAdornment: valid &&
                    !focused &&
                    UtilService.hasValue(getInputValue()) &&
                    !withoutDoneAdornment && <DoneAdornment />,
                  disabled: disabled,
                  name: input.name,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleClickOpen} aria-label={'open'}>
                        <Event />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{
                  shrink: UtilService.hasValue(getInputValue()) || focused,
                }}
                label={isLabelFitToInput(label, width) ? label : ''}
                variant={'outlined'}
                onClick={handleClick}
                margin={'dense'}
                error={touched && !valid}
                placeholder={LabelEnum.DateFormat}
                type="tel"
                className={classNames(classes.inputBackGroundColor, {
                  [classes.withMarginBottom]:
                    withMarginIfValid && (valid || !touched),
                })}
              />
            )}
          </InputMask>
        </FormControl>
      </ControlContainer>
    </>
  );
};

export default DateControl;
